import React from 'react';
import { ALL_COUNTRIES } from '../../utils/countries';

interface CountrySelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
}

const CountrySelect: React.FC<CountrySelectProps> = ({ label, error, className = '', ...props }) => {
  return (
    <div className="country-select-wrapper">
      {label && <label className="form-label fw-semibold">{label}</label>}
      <select 
        className={`form-select ${error ? 'is-invalid' : ''} ${className}`} 
        {...props}
      >
        <option value="">Sélectionner un pays...</option>
        {ALL_COUNTRIES.map((country) => (
          <option key={country.code} value={country.label}>
            {country.flag} {country.label}
          </option>
        ))}
      </select>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default CountrySelect;